var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sdr-box contact-box" }, [
    _c("h4", [_vm._v(_vm._s(_vm.needhelp[_vm.getCurrentLocale]))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.sideboxhelptext[_vm.getCurrentLocale]))]),
    _vm._v(" "),
    _c("address", { staticClass: "contact-details" }, [
      _c("span", { staticClass: "contact-phone" }, [
        _c("i", { staticClass: "soap-icon-message" }),
        _vm._v(" " + _vm._s(_vm.contact[_vm.getCurrentLocale])),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "contact-email",
          attrs: { href: "mailto:slr-vc-service@schauinsland-reisen.de" },
        },
        [_vm._v("slr-vc-service@schauinsland-reisen.de")]
      ),
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.pastsideboxhelptext[_vm.getCurrentLocale]))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }